export default "__VITE_ASSET__BmbnQ2yR__"